import { Box, Grid2, TextField } from "@mui/material";
import { ChangeEvent, useState } from "react";
import "./index.css";
import ButtonComponent from "../../../Components/ButtonComponent";
import emailjs from "emailjs-com";
import useSnackbar from "../../../Components/useSnackbar";

const defaultObj = { email: "",
  firstName: "",
  lastName: "",
  message: "",
  phone: "",}

const ContactUsSection = () => {
  const [data, setData] = useState<{
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    message: string;
  }>({
    ...defaultObj
  });

  const {SnackbarComponent,errorAlert,successAlert} = useSnackbar()

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setData((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const handleSubmit = () => {
    if (
      data.firstName &&
      data.lastName &&
      data.message &&
      data.email &&
      data.phone
    ) {
      const templateParams = {
        user_name: `${data.firstName} ${data.lastName}`,
        user_email: data.email,
        message: data.message,
        phone: data.phone,
      };

      emailjs
        .send(
          process.env.REACT_APP_SERVICE_ID as string,
          process.env.REACT_APP_TEMPLATE_ID as string,
          templateParams,
          process.env.REACT_APP_PUBLIC_KEY
        )
        .then(
          (result) => {
            console.log(result.text);
            successAlert("Our team will reach out to you!")
          },
          (error) => {
            console.log(error.text);
            errorAlert("Something went wrong")
          }
        );
    }
  };
  return (
    <>
    <Box className="contact-section-container img1">
      <Box className="container">
        <Box className="row">
          <Grid2
            container
            sx={{ width: "100%", padding: "20px" }}
            columnSpacing={4}
          >
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box className="comment-respond">
                <Box
                  component="form"
                  sx={{
                    "& .MuiTextField-root": { width: "100%" },
                    "& .MuiBox-root": {
                      m: 1,
                      mb: 4,
                      border: "0px solid red",
                    },
                  }}
                  noValidate
                  autoComplete="off"
                >
                  <Grid2 container rowGap={4} columnSpacing={2}>
                    <Grid2 size={{ xs: 12 }}>
                      <TextField
                        id="outlined-multiline-static"
                        required
                        label="Message"
                        multiline
                        rows={4}
                        defaultValue=""
                        sx={{ width: "100%" }}
                        name="message"
                        value={data.message}
                        onChange={handleChange}
                      />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 6 }}>
                      <TextField
                        required
                        id="outlined-required"
                        label="First name"
                        defaultValue=""
                        name="firstName"
                        value={data.firstName}
                        onChange={handleChange}
                      />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 6 }}>
                      <TextField
                        required
                        id="outlined-required"
                        label="Last name"
                        defaultValue=""
                        name="lastName"
                        value={data.lastName}
                        onChange={handleChange}
                      />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                      <TextField
                        required
                        type="email"
                        id="outlined-required"
                        label="Email Id"
                        defaultValue=""
                        name="email"
                        value={data.email}
                        onChange={handleChange}
                      />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                      <TextField
                        required
                        type="phone"
                        id="outlined-required"
                        label="Phone"
                        defaultValue=""
                        name="phone"
                        value={data.phone}
                        onChange={handleChange}
                      />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                      <ButtonComponent
                        type="button"
                        value="Send Message"
                        width="100%"
                        onClick={handleSubmit}
                      />
                      {/* <button type="submit">Send Message</button> */}
                    </Grid2>
                  </Grid2>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <div className="contact-title leader-content">
                <span>contact us</span>
                <h2>Request a call back?</h2>
                <p style={{ fontWeight: 600 }}>
                  We understand that your time is valuable, and we're here to
                  assist you at your convenience. If you have questions, need
                  support, or would like to discuss a product or service in more
                  detail, simply request a callback, and one of our team members
                  will reach out to you at a time that works best for you. To
                  request a callback, just fill out the form with your name,
                  contact information, and we'll get in touch as soon as
                  possible. We look forward to connecting with you!
                </p>
              </div>
            </Grid2>
          </Grid2>
        </Box>
      </Box>
    </Box>
    <SnackbarComponent />
    </>
  );
};

export default ContactUsSection;
